import { render } from "./modalPrivacy.vue?vue&type=template&id=096586d8&scoped=true"
import script from "./modalPrivacy.vue?vue&type=script&lang=js"
export * from "./modalPrivacy.vue?vue&type=script&lang=js"

import "./modalPrivacy.vue?vue&type=style&index=0&id=096586d8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Edson\\Desktop\\work\\STUDOS PROD\\studiostvapp\\PlatformStudiosApp\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-096586d8"]])

export default __exports__